import { DataType } from "./AnalyticsTracker";
import {
	META_REQUIRES_CONSENT,
	isAnalyticsConsentSatisfied,
} from "./cookieConsentConfig";

export class MetaPixelProvider {
	private isMetaEnabled(): boolean {
		return WEBPACK_ANALYTICS_PROVIDERS.includes("meta-web");
	}

	private hasConsent(): boolean {
		return isAnalyticsConsentSatisfied(META_REQUIRES_CONSENT, "ads");
	}

	constructor() {}

	public trackEvent(eventName: string, data: DataType) {
		if (!this.isMetaEnabled()) {
			return;
		}

		if (!this.hasConsent()) {
			return;
		}

		window.fbq?.("trackCustom", eventName, data);
	}
}
